var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "104px",
    viewBox: "0 0 99 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watch",
    transform: "translate(-10.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG-Circle",
    fill: "#EDEFF3",
    fillRule: "nonzero",
    cx: 59.478,
    cy: 63.354,
    r: 48.906
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.088,92.952 L22.584,92.952 L22.584,46.188 C22.584,44.3004 24.1284,42.756 26.016,42.756 L94.656,42.756 C96.5436,42.756 98.088,44.3004 98.088,46.188 L98.088,92.952 Z",
    id: "Path",
    fill: "#D4DCE6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.892,89.088 C44.892,90.91268 46.335156,92.4166587 48.1364285,92.5148965 L48.324,92.52 L72.348,92.52 C74.17268,92.52 75.6766587,91.076844 75.7748965,89.2755715 L75.78,89.088 L101.073467,89.088662 C98.7093834,92.9016761 95.8356287,96.365547 92.5473515,99.3851261 L26.4086485,99.3851261 C23.1203713,96.365547 20.2466166,92.9016761 17.8825329,89.088662 L44.892,89.088 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.348,56.922 C88.42436,56.922 90.1232,55.22316 90.1232,53.1468 L90,13.5 L29.5968,13.5 L29.72,53.1468 C29.72,55.22316 31.41884,56.922 33.4952,56.922 L86.348,56.922 Z",
    id: "Color-1",
    fill: "#ff4d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.20688,28.608 C65.5282,28.608 66.472,29.5518 66.472,30.87312 L66.4718,34.71 L74.0224,30.30684 C74.9251652,29.9457339 75.8279304,30.4481424 75.9047252,31.3184831 L75.91,31.4394 L75.91,44.46384 C75.91,45.3666052 74.8737825,45.9239646 74.1229003,45.6403359 L74.0224,45.5964 L66.4718,41.192 L66.472,45.21888 C66.472,46.5402 65.5282,47.484 64.20688,47.484 L46.08592,47.484 C44.7646,47.484 43.8208,46.5402 43.8208,45.21888 L43.8208,30.87312 C43.8208,29.5518 44.7646,28.608 46.08592,28.608 L64.20688,28.608 Z",
    id: "Camera",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.348,9.732 C88.3594738,9.732 90.0166538,11.3263215 90.1182633,13.3136876 L90.1232,13.5072 L90.1232,21.0576 L29.72,21.0576 L29.72,13.5072 C29.72,11.4957262 31.3143215,9.83854617 33.3016876,9.73693675 L33.4952,9.732 L86.348,9.732 Z M39.1579999,13.5072 L35.3828,13.5072 L35.3828,17.2824 L39.1579999,17.2824 L39.1579999,13.5072 Z M46.7083997,13.5072 L42.9331998,13.5072 L42.9331998,17.2824 L46.7083997,17.2824 L46.7083997,13.5072 Z M54.2587995,13.5072 L50.4835996,13.5072 L50.4835996,17.2824 L54.2587995,17.2824 L54.2587995,13.5072 Z",
    id: "Color-2",
    fillRule: "nonzero",
    fill: "#db0f37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprove);
export default __webpack_public_path__ + "static/media/improve.b854ba33c954c9ade5d5c455e51ecdfb.svg";
export { ForwardRef as ReactComponent };